import React from 'react';
import './ChecklistModal.css';
import ChecklistForm from './ChecklistForm';

interface ChecklistModalProps {
  open: boolean;
  onClose: () => void;
  checklistId?: number | null;
}

const ChecklistModal: React.FC<ChecklistModalProps> = ({ open, onClose, checklistId }) => {
  if (!open) return null;
  return (
    <div className="checklist-modal-overlay" onClick={onClose}>
      <div className="checklist-modal-content" onClick={e => e.stopPropagation()}>
        <button className="checklist-modal-close" onClick={onClose}>&times;</button>
        <ChecklistForm checklistId={checklistId} onClose={onClose} />
      </div>
    </div>
  );
};

export default ChecklistModal;
